import { DateTime } from 'luxon';

import { RootState } from '@sonar/modules/reducers';
import { Store } from '@sonar/modules/Stores';

export enum OrderStatus {
  None = '',
  Cancelled = 'CANCEL',
  Closed = 'CLOSE',
  InProgress = 'IN_PROGRESS',
  Transferred = 'TRANSFER',
}

export interface OrderInfo {
  readonly orderCustomersCount: number;
  readonly orderTotalTaxAmount: number;
  readonly orderTotalCancelled: number;
  readonly orderDiscountAmount: number;
  readonly orderTotalDiscount: number;
  readonly orderCreatedAt: string;
  readonly orderClosedAt: string;
  readonly storeId: string;
  readonly orderName: string;
  readonly openingStaffName: string;
  readonly closingStaffName: string;
  readonly tableName: string;
  readonly orderStatus: OrderStatus;
  readonly orderTotalTaxIncluded: number;
  readonly orderTotalTaxExcluded: number;
  readonly orderUuid: string;
  readonly orderOpenedAt: string;
  readonly sumPayments: number;
}

export interface AggregatedOrderInfo {
  readonly sumOrderCustomersCount: number;
  readonly sumOrderTotalTaxIncluded: number;
  readonly sumOrderTotalTaxExcluded: number;
  readonly sumOrderTotalTaxAmount: number;
  readonly sumOrderTotalCancelled: number;
  readonly sumOrderDiscountAmount: number;
  readonly sumOrderTotalDiscount: number;
  readonly sumOrderAverageSpentTaxIncluded: number;
  readonly sumOrderAverageSpentTaxExcluded: number;
  readonly orderStatus?: OrderStatus;
  readonly hour?: DateTime;
  readonly day?: DateTime;
  readonly week?: DateTime;
  readonly sevenDays?: DateTime;
  readonly month?: DateTime;
  readonly year?: DateTime;
}

export interface OrderInfoWithStore extends OrderInfo {
  readonly store: Store;
}

export type RootStateWithOrders = Pick<RootState, 'orders'>;
